import { render, staticRenderFns } from "./ReserveTransfersTable.vue?vue&type=template&id=dcb70c7a&"
import script from "./ReserveTransfersTable.vue?vue&type=script&lang=js&"
export * from "./ReserveTransfersTable.vue?vue&type=script&lang=js&"
import style0 from "./ReserveTransfersTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports